import React from "react";
import T from "prop-types";
import { Warning } from "MODULES/shared/components";
import { DO_NOT_EXCHANGE } from "MODULES/companies/constants";

function DoNotExchangeWarning({ company }) {
  if (!company) return null;
  if (!company[DO_NOT_EXCHANGE]) return null;
  return (
    <Warning>
      This company is flagged with a do not exchange restriction.
    </Warning>
  );
}

DoNotExchangeWarning.propTypes = {
  company: T.shape({})
};

export default DoNotExchangeWarning;



// WEBPACK FOOTER //
// ./app/modules/companies/shared/components/DoNotExchangeWarning.jsx